

(() => {
  const canvas = document.getElementById("pacman-canvas");
  if (!canvas) return;

  const ctx = canvas.getContext("2d");
  const startBtn = document.getElementById("pacman-start");
  const retryBtn = document.getElementById("pacman-retry");
  const statusEl = document.getElementById("pacman-status");
  const winBox = document.getElementById("pacman-win");

  const tipEl = document.getElementById("pacman-mobile-tip");
  const dpadWrap = document.getElementById("touch-dpad");
  const joyWrap = document.getElementById("touch-joystick");
  const joyArea = document.getElementById("joy-area");
  const joyKnob = document.getElementById("joy-knob");

  // ====== HARD SETTINGS (locked) ======
  const HARD = {
    playerSpeed: 2.35,
    ghostSpeed: 2.55,
    timerSeconds: 55,
    ghostAggro: 0.9,
    pelletCountTarget: 0
  };

  // 0 empty, 1 wall, 2 pellet
  const map = [
    "11111111111111111111",
    "12000020000020000021",
    "10111101111101111101",
    "10200001000001000001",
    "10101111101111101101",
    "10001000001000001001",
    "11101011111011101011",
    "12001010000000100021",
    "10111010111110101101",
    "10000000100000100001",
    "10111111101111111101",
    "12000020000020000021",
    "11111111111111111111"
  ].map(row => row.split("").map(ch => Number(ch)));

  const TILE = 32;
  const W = map[0].length * TILE;
  const H = map.length * TILE;

  canvas.width = W;
  canvas.height = H;

  // Keyboard control state (kept for desktop + reused by d-pad)
  let keys = {};

  window.addEventListener("keydown", (e) => {
    const k = e.key.toLowerCase();
    if (["arrowup","arrowdown","arrowleft","arrowright","w","a","s","d"].includes(k)) {
      e.preventDefault();
      keys[k] = true;
    }
  }, { passive: false });

  window.addEventListener("keyup", (e) => {
    keys[e.key.toLowerCase()] = false;
  });

  // Analog control state (preferred on touch when active)
  let analogActive = false;
  let analogVec = { x: 0, y: 0 }; // normalized -1..1

  const rand = (a,b) => a + Math.random()*(b-a);

  function resetPellets() {
    let count = 0;
    for (let y=0; y<map.length; y++) {
      for (let x=0; x<map[0].length; x++) {
        if (map[y][x] === 0) {
          if ((x+y)%2===0 && Math.random() > 0.05) map[y][x] = 2;
        }
        if (map[y][x] === 2) count++;
      }
    }
    HARD.pelletCountTarget = count;
  }

  const player = {
    x: TILE * 1.5,
    y: TILE * 1.5,
    r: TILE * 0.38,
    score: 0
  };

  const ghosts = [
    { x: TILE*18.5, y: TILE*1.5,  r: TILE*0.38, vx: 0, vy: 0 },
    { x: TILE*18.5, y: TILE*11.5, r: TILE*0.38, vx: 0, vy: 0 }
  ];

  let running = false;
  let last = 0;
  let remaining = HARD.timerSeconds;
  let timerId = null;

  function tileAt(px, py) {
    const tx = Math.floor(px / TILE);
    const ty = Math.floor(py / TILE);
    if (ty < 0 || ty >= map.length || tx < 0 || tx >= map[0].length) return 1;
    return map[ty][tx];
  }

  function isWall(px, py) {
    return tileAt(px, py) === 1;
  }

  function circleHitsWall(cx, cy, r) {
    const pts = [
      [cx+r, cy], [cx-r, cy], [cx, cy+r], [cx, cy-r],
      [cx+r*0.7, cy+r*0.7], [cx-r*0.7, cy+r*0.7],
      [cx+r*0.7, cy-r*0.7], [cx-r*0.7, cy-r*0.7]
    ];
    return pts.some(([x,y]) => isWall(x,y));
  }

  function eatPellet() {
    const tx = Math.floor(player.x / TILE);
    const ty = Math.floor(player.y / TILE);
    if (map[ty] && map[ty][tx] === 2) {
      map[ty][tx] = 0;
      player.score++;
    }
  }

  function dist(a,b) {
    const dx = a.x-b.x, dy = a.y-b.y;
    return Math.hypot(dx, dy);
  }

  function setStatus(text) {
    if (statusEl) statusEl.textContent = text || "";
  }

  function showWin() {
    if (winBox) winBox.style.display = "block";
  }

  function hideWin() {
    if (winBox) winBox.style.display = "none";
  }

  function lose(reason) {
    running = false;
    clearInterval(timerId);
    timerId = null;
    setStatus(`❌ ${reason} — Retry!`);
  }

  function win() {
    running = false;
    clearInterval(timerId);
    timerId = null;
    setStatus(`✅ You win!`);
    showWin();
  }

  // Keep original walls layout but reset pellets/empties
  const baseMap = map.map(row => row.slice());
  function resetMapToBase() {
    for (let y=0; y<map.length; y++) {
      for (let x=0; x<map[0].length; x++) {
        map[y][x] = baseMap[y][x];
        if (map[y][x] === 2) map[y][x] = 0;
      }
    }
  }

  function getInputVector() {
    // If analog active (touch joystick), use it
    if (analogActive && (Math.abs(analogVec.x) > 0.01 || Math.abs(analogVec.y) > 0.01)) {
      return { x: analogVec.x, y: analogVec.y };
    }

    // Else, use keyboard/dpad keys
    let ax = 0, ay = 0;
    const up = keys["arrowup"] || keys["w"];
    const down = keys["arrowdown"] || keys["s"];
    const left = keys["arrowleft"] || keys["a"];
    const right = keys["arrowright"] || keys["d"];

    if (up) ay -= 1;
    if (down) ay += 1;
    if (left) ax -= 1;
    if (right) ax += 1;

    const len = Math.hypot(ax, ay) || 1;
    return { x: ax/len, y: ay/len };
  }

  function handlePlayer(dt) {
    const v = getInputVector();

    const sp = HARD.playerSpeed;
    const nx = player.x + v.x * sp * dt;
    const ny = player.y + v.y * sp * dt;

    if (!circleHitsWall(nx, player.y, player.r)) player.x = nx;
    if (!circleHitsWall(player.x, ny, player.r)) player.y = ny;

    eatPellet();

    if (player.score >= HARD.pelletCountTarget) {
      win();
    }
  }

  function chooseGhostDir(g) {
    const chase = Math.random() < HARD.ghostAggro;
    const dirs = [{x:1,y:0},{x:-1,y:0},{x:0,y:1},{x:0,y:-1}];

    const valid = dirs.filter(d => {
      const nx = g.x + d.x * TILE * 0.35;
      const ny = g.y + d.y * TILE * 0.35;
      return !circleHitsWall(nx, ny, g.r);
    });

    if (!valid.length) return {x:0,y:0};

    if (!chase) return valid[Math.floor(Math.random()*valid.length)];

    let best = valid[0];
    let bestScore = Infinity;
    for (const d of valid) {
      const nx = g.x + d.x * TILE;
      const ny = g.y + d.y * TILE;
      const dd = Math.hypot(player.x - nx, player.y - ny);
      if (dd < bestScore) {
        bestScore = dd;
        best = d;
      }
    }
    return best;
  }

  function handleGhost(g, dt) {
    const tx = (g.x / TILE);
    const ty = (g.y / TILE);
    const nearCenter = (Math.abs(tx - Math.round(tx)) < 0.12) && (Math.abs(ty - Math.round(ty)) < 0.12);

    if (nearCenter || (g.vx === 0 && g.vy === 0)) {
      const d = chooseGhostDir(g);
      g.vx = d.x;
      g.vy = d.y;
    }

    const sp = HARD.ghostSpeed;
    const nx = g.x + g.vx * sp * dt;
    const ny = g.y + g.vy * sp * dt;

    if (!circleHitsWall(nx, g.y, g.r)) g.x = nx; else g.vx *= -1;
    if (!circleHitsWall(g.x, ny, g.r)) g.y = ny; else g.vy *= -1;
  }

  function draw() {
    ctx.clearRect(0,0,W,H);

    for (let y=0; y<map.length; y++) {
      for (let x=0; x<map[0].length; x++) {
        const t = map[y][x];
        const px = x*TILE, py = y*TILE;

        if (t === 1) {
          ctx.fillStyle = "rgba(120,160,255,0.28)";
          ctx.fillRect(px, py, TILE, TILE);
        } else {
          ctx.fillStyle = "rgba(10,16,32,1)";
          ctx.fillRect(px, py, TILE, TILE);

          if (t === 2) {
            ctx.beginPath();
            ctx.fillStyle = "rgba(255,255,255,0.95)";
            ctx.arc(px + TILE/2, py + TILE/2, TILE*0.12, 0, Math.PI*2);
            ctx.fill();
          }
        }
      }
    }

    // player
    ctx.beginPath();
    ctx.fillStyle = "rgba(255,215,0,0.95)";
    ctx.arc(player.x, player.y, player.r, 0, Math.PI*2);
    ctx.fill();

    // ghosts
    ghosts.forEach((g,i) => {
      ctx.beginPath();
      ctx.fillStyle = i===0 ? "rgba(255,80,120,0.95)" : "rgba(120,255,180,0.95)";
      ctx.arc(g.x, g.y, g.r, 0, Math.PI*2);
      ctx.fill();
    });

    ctx.fillStyle = "rgba(255,255,255,0.85)";
    ctx.font = "16px system-ui, -apple-system, Segoe UI, Roboto, Arial";
    ctx.fillText(`HARD | Candies: ${player.score}/${HARD.pelletCountTarget} | Time: ${remaining}s`, 14, 22);
  }

  function loop(ts) {
    if (!running) {
      draw();
      return;
    }
    const dt = Math.min(0.033, (ts - last) / 1000);
    last = ts;

    handlePlayer(dt);
    ghosts.forEach(g => handleGhost(g, dt));

    for (const g of ghosts) {
      if (dist(player, g) < player.r + g.r - 4) {
        lose("Caught by ghosts");
        break;
      }
    }

    draw();
    requestAnimationFrame(loop);
  }

  function start() {
    hideWin();
    resetMapToBase();
    resetPellets();

    player.x = TILE * 1.5;
    player.y = TILE * 1.5;
    player.score = 0;

    ghosts[0].x = TILE*18.5; ghosts[0].y = TILE*1.5;  ghosts[0].vx=0; ghosts[0].vy=0;
    ghosts[1].x = TILE*18.5; ghosts[1].y = TILE*11.5; ghosts[1].vx=0; ghosts[1].vy=0;

    remaining = HARD.timerSeconds;
    setStatus(`🍬 0/${HARD.pelletCountTarget} | ⏱️ ${remaining}s | HARD`);
    running = true;
    last = performance.now();

    clearInterval(timerId);
    timerId = setInterval(() => {
      if (!running) return;
      remaining--;
      setStatus(`🍬 ${player.score}/${HARD.pelletCountTarget} | ⏱️ ${remaining}s | HARD`);
      if (remaining <= 0) lose("Time up");
    }, 1000);

    requestAnimationFrame(loop);
  }

  // ========= MOBILE CONTROLS (all 3) =========
  const isTouch = window.matchMedia("(pointer: coarse)").matches;

  function showMobileUI() {
    if (tipEl) tipEl.style.display = "block";
    if (dpadWrap) dpadWrap.style.display = "block";
    if (joyWrap) joyWrap.style.display = "flex";
  }

  // (1) D-PAD: press & hold a direction
  function setupDpad() {
    if (!dpadWrap) return;
    const btns = dpadWrap.querySelectorAll("button[data-dir]");
    btns.forEach(btn => {
      const dir = btn.dataset.dir;

      const setDir = (d) => {
        // D-pad uses keys state; also disable analog while pressing D-pad
        analogActive = false;
        analogVec = { x: 0, y: 0 };

        keys = {};
        if (d === "up") keys["arrowup"] = true;
        if (d === "down") keys["arrowdown"] = true;
        if (d === "left") keys["arrowleft"] = true;
        if (d === "right") keys["arrowright"] = true;
      };

      const clearDir = () => {
        keys = {};
      };

      btn.addEventListener("touchstart", e => {
        e.preventDefault();
        setDir(dir);
      }, { passive: false });

      btn.addEventListener("touchend", e => {
        e.preventDefault();
        clearDir();
      }, { passive: false });

      btn.addEventListener("touchcancel", e => {
        e.preventDefault();
        clearDir();
      }, { passive: false });
    });
  }

  // (2) SWIPE: swipe on canvas to set direction (quick control)
  function setupSwipe() {
    let startX = 0, startY = 0, active = false;

    const onStart = (e) => {
      if (!e.touches || e.touches.length !== 1) return;
      active = true;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    };

    const onMove = (e) => {
      if (!active || !e.touches || e.touches.length !== 1) return;
      // prevent scroll while swiping on canvas
      e.preventDefault();
    };

    const onEnd = (e) => {
      if (!active) return;
      active = false;

      const t = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0] : null;
      if (!t) return;

      const dx = t.clientX - startX;
      const dy = t.clientY - startY;
      const adx = Math.abs(dx);
      const ady = Math.abs(dy);

      // threshold
      if (Math.max(adx, ady) < 18) return;

      // swipe chooses a cardinal dir; uses keys
      analogActive = false;
      analogVec = { x: 0, y: 0 };

      keys = {};
      if (adx > ady) {
        if (dx > 0) keys["arrowright"] = true;
        else keys["arrowleft"] = true;
      } else {
        if (dy > 0) keys["arrowdown"] = true;
        else keys["arrowup"] = true;
      }

      // small timeout to avoid “sticking”
      setTimeout(() => { keys = {}; }, 140);
    };

    canvas.addEventListener("touchstart", onStart, { passive: true });
    canvas.addEventListener("touchmove", onMove, { passive: false });
    canvas.addEventListener("touchend", onEnd, { passive: true });
    canvas.addEventListener("touchcancel", onEnd, { passive: true });
  }

  // (3) ANALOG JOYSTICK: hold & drag, gives smooth vector
  function setupAnalogJoystick() {
    if (!joyArea || !joyKnob) return;

    let tracking = false;
    let baseRect = null;
    let center = { x: 0, y: 0 };
    const maxRadius = 78; // px for knob travel

    const setKnob = (dx, dy) => {
      // limit
      const mag = Math.hypot(dx, dy) || 1;
      let lx = dx, ly = dy;
      if (mag > maxRadius) {
        lx = (dx / mag) * maxRadius;
        ly = (dy / mag) * maxRadius;
      }
      joyKnob.style.transform = `translate(calc(-50% + ${lx}px), calc(-50% + ${ly}px))`;

      // normalize to -1..1
      analogVec.x = lx / maxRadius;
      analogVec.y = ly / maxRadius;
    };

    const resetKnob = () => {
      joyKnob.style.transform = "translate(-50%,-50%)";
      analogVec = { x: 0, y: 0 };
    };

    const onStart = (e) => {
      if (!e.touches || e.touches.length !== 1) return;
      tracking = true;
      analogActive = true;
      keys = {}; // prefer analog when active

      baseRect = joyArea.getBoundingClientRect();
      center = { x: baseRect.left + baseRect.width/2, y: baseRect.top + baseRect.height/2 };

      const t = e.touches[0];
      setKnob(t.clientX - center.x, t.clientY - center.y);
      e.preventDefault();
    };

    const onMove = (e) => {
      if (!tracking || !e.touches || e.touches.length !== 1) return;
      const t = e.touches[0];
      setKnob(t.clientX - center.x, t.clientY - center.y);
      e.preventDefault();
    };

    const onEnd = (e) => {
      tracking = false;
      // keep analogActive true but vector zeroed, so keyboard can take over if needed
      resetKnob();
    };

    joyArea.addEventListener("touchstart", onStart, { passive: false });
    joyArea.addEventListener("touchmove", onMove, { passive: false });
    joyArea.addEventListener("touchend", onEnd, { passive: true });
    joyArea.addEventListener("touchcancel", onEnd, { passive: true });
  }

  if (isTouch) {
    showMobileUI();
    setupDpad();
    setupSwipe();
    setupAnalogJoystick();
  }

  // Buttons
  startBtn?.addEventListener("click", start);
  retryBtn?.addEventListener("click", start);

  // initial paint
  resetMapToBase();
  resetPellets();
  setStatus(`Ready | HARD only`);
  draw();
})();


